import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactDOM from "react-dom";
import currency from "currency.js";
export default class CoolerModal extends React.Component {
    constructor(props) {
        super(props);
        // ─── Handle Submitting Cooler Bag Form ───────────────────────────────
        this.submitForm = (e) => {
            this.setState({
                isSubmitting: true,
            });
            e.currentTarget.closest("form").submit();
        };
        // ─── Calculate Estimated Bags Required For Order ─────────────────────
        this.estimatedBagsRequired = () => Math.ceil(this.props.itemQuantity / 10).toString();
        // ─── Callback To Update Number Of Bags ───────────────────────────────
        this.updateQty = (e) => {
            this.setState({
                bags: e.currentTarget.value,
            });
        };
        this.state = {
            show: props.show || false,
            bags: this.estimatedBagsRequired(),
            isSubmitting: false,
        };
    }
    render() {
        const { onExit, coolerBag } = this.props;
        const { show, bags, isSubmitting } = this.state;
        return ReactDOM.createPortal(React.createElement(Modal, { id: "cooler-bag-modal", show: show, onHide: () => this.showModal(false), dialogClassName: "modal-dialog-centered rfg-modal", backdrop: isSubmitting ? "static" : undefined, onExit: onExit },
            React.createElement("form", { action: "/cart", method: "post" },
                React.createElement(Modal.Header, { closeButton: !isSubmitting },
                    React.createElement(Modal.Title, null,
                        React.createElement("h5", { className: "modal-title", id: "simple-modal" },
                            React.createElement("i", { className: "far fa-snowflake" }),
                            " Cooler bags"))),
                React.createElement(Modal.Body, null,
                    React.createElement("p", null, "Our meal subscriptions are shipped in 2 deliveries spread over the week. If you're not in to accept your delivery, you can keep your delivery perfectly fresh with our cooler bags."),
                    React.createElement("p", null,
                        "Each bag holds 10-12 meals, and we recommend you'll need ",
                        this.estimatedBagsRequired(),
                        " bags for your order"),
                    React.createElement("p", null,
                        "Cooler bags are",
                        " ",
                        React.createElement("strong", null,
                            currency((coolerBag === null || coolerBag === void 0 ? void 0 : coolerBag.price) || 0).format(),
                            " each"))),
                React.createElement(Modal.Footer, { className: "split-btn-row" },
                    React.createElement("button", { type: "button", className: "btn btn-secondary", disabled: isSubmitting, onClick: () => this.showModal(false) }, "Close")))), document.getElementById("cart-modal-container"));
    }
    // ─── Toggle Modal On Or Off ──────────────────────────────────────────
    showModal(showOrHide) {
        this.setState({
            show: showOrHide,
        });
    }
    // ─── Manage Updated Props ────────────────────────────────────────────
    componentDidUpdate(prevProps) {
        //Toggle showing modal
        if (prevProps.show != this.props.show) {
            this.showModal(this.props.show);
        }
    }
}
